import React from 'react';
import Layout from '../../components/Layout/Layout';
import CardCompany from '../../components/CardCompany/CardCompany';
import styles from './CardCompanyPage.module.css';

const CardCompanyPage = () => {
  const handleClose = () => {
    console.log('Card company closed');
  };

  return (
    <Layout width="1440px">
      <div className={styles.cardCompanyStack}>
        <CardCompany
          companyId="ff271c2a-d2a7-426f-bbe1-599e98d870ba"
          size="Desktop 1440"
          onClose={handleClose}
        />
      </div>
    </Layout>
  );
};

export default CardCompanyPage;